import {
  getBillingBlockFromAxiosError,
  getBillingDisplayMessage,
} from './standard-billing-payload';

export function getProductBillingBlockUserMessage(error: unknown): string | null {
  const block = getBillingBlockFromAxiosError(error);
  if (!block) return null;
  return getBillingDisplayMessage(block);
}
